import { Button, FormLabel, Grid, Modal, Switch, TextField } from "@mui/material";
import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import ContainerModal from "../../../../../components/modalExportar/components/containerModal";
import CloseButton from "../../../../../components/botoes/close";
import ServicesEdit from "./services";
import SkeletonEditEvents from "./skeleton";


interface EditarEventoBatismoProps {

}

const EditarEventoBatismo: FunctionComponent<EditarEventoBatismoProps> = () => {

  const nav = useNavigate();

  const onClose = () => {
    nav(-1);
  }

  const { alterEvento, isLoading, submitUpdate, evento } = ServicesEdit();

  return (<>
    <Modal open onClose={onClose}>
      <ContainerModal>
        <div style={{ display: 'flex', alignItems: 'center', padding: '4px', borderBottom: '1px solid #ccc', justifyContent: 'space-between' }}>
          <p style={{ fontSize: '16px', fontWeight: '600' }}>Editar Evento</p>
          <CloseButton onClick={onClose} />
        </div>
        <Grid sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', padding: '4px' }}>
          {
            isLoading ? <SkeletonEditEvents /> :
              <>
                <Grid>
                  <FormLabel>Ativo</FormLabel>
                  <Switch defaultChecked={false} checked={evento?.ativo} onClick={() => alterEvento('ativo', !evento?.ativo)} />
                </Grid>
                <Grid>
                  <FormLabel>Permite Inscrição?</FormLabel>
                  <Switch defaultChecked={false} checked={evento?.inscricao} onClick={() => alterEvento('inscricao', !evento?.inscricao)} />
                </Grid>
                <Grid>
                  <FormLabel>Início</FormLabel>
                  <TextField type="datetime" defaultValue={evento?.inicio} value={evento?.inicio} onChange={(event) => alterEvento('inicio', event?.target?.value)} />
                </Grid>
                <Grid>
                  <FormLabel>Fim</FormLabel>
                  <TextField type="datetime" defaultValue={evento?.fim} value={evento?.fim} onChange={(event) => alterEvento('fim', event?.target?.value)} />
                </Grid>
                <Grid>
                  <FormLabel>Whatsapp</FormLabel>
                  <TextField defaultValue={evento?.whatsapp} value={evento?.whatsapp} onChange={(event) => alterEvento('whatsapp', event?.target?.value)} />
                </Grid>
                <Grid>
                  <FormLabel>CEP</FormLabel>
                  <TextField defaultValue={evento?.cep} value={evento?.cep} onChange={(event) => alterEvento('cep', event?.target?.value)} />
                </Grid>
              </>
          }
        </Grid>
        <div style={{ padding: '8px', marginTop: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button color="error" onClick={onClose}>Cancelar</Button>
          <Button sx={{ boxShadow: 'none' }} variant="contained" onClick={submitUpdate}>Confirmar</Button>
        </div>
      </ContainerModal>
    </Modal>
  </>);
}

export default EditarEventoBatismo;
